export default "__VITE_ASSET__B6FZkhmF__"